import { createAction } from '@reduxjs/toolkit';

export const CatalogExplorerLanguagesActions = {
  navigateTo: createAction<{ navigateTo: string }>('CatalogsListPage/NavigateTo'),
};
